module.exports = __webpack_public_path__ + "static/media/sampleTemplate.ddb39f7e.xlsx";